import React, { useEffect } from 'react';
import i18n from '../../utils/i18n';
import Input from '../../ui/Input';
import { Control, Controller, UseFormSetValue, useWatch } from 'react-hook-form';
import { convertTextToUrl } from '../../utils/convertTextToUrl';
import { useConfig } from '../Config/config';

interface IAliasLink {
    control: Control<any>;
    name: string;
    setValue: UseFormSetValue<any>;
}

const AliasLink = ({ control, setValue, name }: IAliasLink) => {
    const { config } = useConfig();
    const id = useWatch({ name: 'id', control });
    const brand = useWatch({ name: 'brand', control });
    const productName = useWatch({ name: 'name', control });

    useEffect(() => {
        if (id) return;
        if (brand || productName) {
            const brandAlias = brand && config.brands.find((item) => item.id === brand.id)?.alias;
            setValue(name, convertTextToUrl(`${brandAlias ? brandAlias + '-' : ''}${productName}`));
        }
    }, [brand, productName]);

    return (
        <Controller
            name={name}
            control={control}
            rules={{ required: true, pattern: { message: i18n.general.wrongFormat, value: /[a-z0-9\-]+/ } }}
            defaultValue={''}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
                <Input
                    value={value}
                    onChange={onChange}
                    error={!!error}
                    errorMessage={error?.message}
                    label={i18n.general.link}
                    infoMessage={i18n.product.linkHint}
                    disabled
                />
            )}
        />
    );
};

export default AliasLink;
